/**
 * defines the structures to be used with a 'quiz category results'
 */
import { PropTypes } from 'console-kit';

const QuizCategoryResultDataPropType = {
  resultTitle:          PropTypes.string,
  resultDescription:    PropTypes.string,
  url:                  PropTypes.string,
  imageAssetRef:        PropTypes.string,
  imageAssetRefAltText: PropTypes.string,
  shareDescription:     PropTypes.string,
  resultValue:          PropTypes.string,
};

const QuizCategoryResultData = {
  resultTitle:          '',
  resultDescription:    '',
  url:                  '',
  imageAssetRef:        '',
  imageAssetRefAltText: '',
  shareDescription:     '',
  resultValue:          '',
};

export { QuizCategoryResultDataPropType, QuizCategoryResultData };
